<template>
  <div class="questions">
    <div v-show="hasContent" v-for="item in title_questionList" :key="item.id">
      <el-row>
        <el-col class="presonal-title" :span="24">
          <span>{{ item.courseName }}</span>
        </el-col>
      </el-row>
      <el-row class="content">
        <el-col :span="24">
          <div
            class="question"
            v-for="questionItem in item.question"
            :key="questionItem.id"
            @click="
              handeChange(
                questionItem.question,
                questionItem.id,
                questionItem.created_at
              )
            "
          >
            <div class="question-news">
              <img :src="questionItem.photo" alt="" />
              <div class="news" v-show="questionItem.show_count">
                {{ questionItem.show_count }}
              </div>
            </div>
            <div class="question-info">
              <p>{{ questionItem.question }}</p>
              <p>{{ questionItem.created_at }}</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-empty
      :description="$t('lang.external.personal.content.five.暂无数据！')"
      :image-size="200"
      v-show="emptyShow"
    ></el-empty>
  </div>
</template>

<script>
import { questionLists } from '@/api/personalCenter/index.js'
import { formatLan } from '@/utils/lanFormat'
export default {
  name: 'questions',
  components: {},
  props: [],
  data() {
    return {
      hasContent: true,
      emptyShow: false,
      requestSum: 0,
      title_questionList: [],
    }
  },
  watch: {},
  computed: {
    serverUrl() {
      return this.publicData.serverUrl
    },
  },
  created() {
    this.require_questionList()
  },
  mounted() {},
  methods: {
    handeChange(title, id, created_at) {
      this.$emit('change', false)
      this.$store.commit('personal/SET_QUESTION_TITLE', title)
      this.$store.commit('personal/SET_QUESTION_ID', id)
      this.$store.commit('personal/SET_QUESTION_TIME', created_at)
    },
    require_questionList() {
      questionLists().then((res) => {
        const { data } = res
        const array = []
        for (let i = 0; i < data.length; i++) {
          data[i]['courseName'] = formatLan(data[i]['courseName'])
          array.push(data[i])
        }
        this.title_questionList = array
        if (this.title_questionList.length === 0) {
          this.hasContent = false
          this.emptyShow = true
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.questions {
  width: 100%;
  // height: 300px;
  .el-row {
    background-color: #fafbfc;
  }
  .content {
    border-radius: 0 0 4px 4px;
    padding: 10px 45px 30px;
    margin-bottom: 15px;
  }
  .question {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #eaeaea;
    cursor: pointer;
    &-news {
      position: relative;
      .news {
        position: absolute;
        top: 0;
        left: -10%;
        width: 26px;
        height: 18px;
        border-radius: 9px;
        color: #fff;
        background-color: #a63528;
        text-align: center;
        line-height: 18px;
      }
      img {
        width: 3vw;
        height: 3vw;
        border-radius: 50%;
      }
    }
    &-info {
      width: 100%;
      padding: 15px 20px;
      p {
        margin: 0;
        &:last-child {
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>